/*eslint-disable */
//Conflict between Prettier and eslint regarding the error Missing parentheses around multilines JSX  react/jsx-wrap-multilines
import React, { FC, memo, useCallback } from "react";
import { createUseStyles } from "react-jss";

import styles from "./styles";
import SearchOptions from "Components/SearchOptions";
import { setCurrentView } from "Containers/MapSwitcher/mapSwitcher.Actions";
import { areEqual, areEqualShallow } from "Utils/areEqual";
import Icon from "Components/Icons";
import { useDispatch, useSelector } from "react-redux";

interface Props {
  resetTrails: () => void;
  goToDestinations: () => void;
  goToCampusMap: () => void;
  showSwitcher: boolean;
  usedSwitcher: boolean;
  setShowTrails: (showTrails: boolean) => void;
  showTrails: boolean;
  setSearchOptionsView: (
    view: string,
    showSearchOptionsMobile?: boolean
  ) => void;
  showDefaultMobileSearchOptions: boolean;
  setShowDefaultMobileSearchOptions: (status: boolean) => void;
  selectedTrail: string;
}
const SearchOptionsDestinations: FC<Props> = memo(
  ({
    resetTrails,
    goToDestinations,
    goToCampusMap,
    usedSwitcher,
    setShowTrails,
    showTrails, //Default to no stops
    setSearchOptionsView,
    showDefaultMobileSearchOptions,
    setShowDefaultMobileSearchOptions,
    selectedTrail,
    showSwitcher,
  }: Props) => {
    const useStyles = createUseStyles(styles);
    const classes = useStyles();
    const dispatch = useDispatch();
    const view = useSelector((store: any) => store.searchOptionsView.view);
    const currentView = useSelector(
      (store: any) => store.mapSwitcher.currentView
    );
    const { modules } = useSelector(
      (selectors: any) => selectors.locationModulesMatrix,
      areEqual
    );
    const { platform, originalSource } = useSelector(
      (store: any) => store.tour
    );
    const directionsModule = modules?.filter((obj) => {
      return obj.moduleid === "directions";
    })[0];

    const showDirectionsModule = () => {
      let correctPlatform;
      if (platform === "w") correctPlatform = "web";
      if (platform === "v") correctPlatform = "vhost";
      if (!platform) correctPlatform = originalSource;
      return directionsModule[correctPlatform] === "1" ? true : false;
    };
    const gotToDirections = useCallback(() => {
      if (currentView === "campusmap")
        dispatch(setCurrentView("mapview", false));
      resetTrails();
      setSearchOptionsView("directions"); //I want searchOptionsView to be true
    }, [setSearchOptionsView, currentView]);

    const currentLabelClick = useCallback(() => {
      setShowTrails(!showTrails);
    }, [showTrails]);


    //DesktopView
    return (
      <>
      {
        view === "trails" && (
          <SearchOptions
        showTrails={showTrails}
        arrowSlot={
          <div className={!showTrails && classes.hideMobileLandscape}>
            <Icon
              type={"leftarrow"}
              events={{
                onClick:
                  usedSwitcher || !showSwitcher
                    ? goToDestinations
                    : goToCampusMap,
              }}
            />
          </div>
        }
        key={`showDestinations-desktop-trails`}
        slot1={<Icon type={"trails"} tabIndex={-1} />}
        textLabel={
          <Icon
            text={selectedTrail ? selectedTrail : "Trails"}
            type={"textLabel"}
            events={{ onClick: currentLabelClick }}
            className={`${classes.button}`}
          />
        }
        slot2={
          directionsModule &&
          showDirectionsModule() && (
            <div className={!showTrails && classes.hideMobileLandscape}>
              <Icon type={"directions"} events={{ onClick: gotToDirections }} />
            </div>
          )
        }
        slot3={
          <div className={!showTrails && classes.hideMobileLandscape}>
            <Icon
              type={"close"}
              events={{
                onClick:
                  usedSwitcher || !showSwitcher
                    ? goToDestinations
                    : goToCampusMap,
              }}
            />
          </div>
        }
      />
        )
      }
    </>
    );
  },
  areEqualShallow
);

export default SearchOptionsDestinations;
